<template>
  <CortonaIPC
    v-if="model && model.type === 'CORTONA_IPC'"
    :model="model"
    :vin="currentVin"
    :autoSelectView="autoSelectView"
    :autoSelectPart="autoSelectPart"
    @reload="prepareModelData()"
    @removeVIN="removeVIN"
    @updateVIN="updateVIN"
    @closeDialog="closeDialog"
    @modelNavigation="onModelNavigation"
  ></CortonaIPC>

  <CortonaINS
    v-else-if="model && model.type === 'CORTONA_WORK_INSTRUCTION'"
    :model="model"
    @reload="prepareModelData()"
    @closeDialog="closeDialog"
  ></CortonaINS>

  <resource-image-preview
    v-else-if="model && model.type === 'FILE' && model.mimeType.startsWith('image/')"
    :model="model"
    :iframe-style="'height: 100vh; width: 100vw; border: 0'"
    @closeDialog="closeDialog"
  >
  </resource-image-preview>

  <resource-pdf-preview
    v-else-if="model && model.type === 'FILE' && model.mimeType === 'application/pdf'"
    :model="model"
    @closeDialog="closeDialog"
  >
  </resource-pdf-preview>

  <resource-text-preview
    v-else-if="model && model.type === 'FILE' && (model.mimeType === 'text/csv' || model.mimeType.startsWith('text/'))"
    :model="model"
    @closeDialog="closeDialog"
  >
  </resource-text-preview>

  <resource-unsupported-preview
    v-else-if="model"
    :model="model"
    @closeDialog="closeDialog"
  >
  </resource-unsupported-preview>
</template>

<script>
import CortonaIPC from './CortonaIPC.vue';
import api from '../../services/api';
import CortonaINS from './CortonaINS.vue';
import ResourceImagePreview from '@/venit/components/cortona-venit/components/cortona/ResourceImage.vue';
import ResourcePdfPreview from '@/venit/components/cortona-venit/components/cortona/ResourcePdf.vue';
import ResourceUnsupportedPreview from '@/venit/components/cortona-venit/components/cortona/ResourceUnsupported.vue';
import ResourceTextPreview from '@/venit/components/cortona-venit/components/cortona/ResourceText.vue';
import { useCortonaViewerStore } from '@/stores/cortonaViewer';

export default {
  name: 'Model',
  components: { ResourceImagePreview: ResourceImagePreview, ResourcePdfPreview: ResourcePdfPreview, ResourceTextPreview: ResourceTextPreview, ResourceUnsupportedPreview: ResourceUnsupportedPreview, CortonaIPC, CortonaINS },
  props: {
    id: String,
    vin: String,
    autoSelectView: String,
    autoSelectPart: String,
  },
  data() {
    return {
      model: null,
      currentId: this.id,
      currentVin: this.vin,
    };
  },
  emits: ['closeDialog'],
  methods: {
    async closeDialog() {
      this.model = null;
      const cortonaViewerStore = useCortonaViewerStore();
      cortonaViewerStore.navigateToModel(null, true);
      this.$emit('closeDialog');
    },
    async prepareModelData() {
      this.model = null;
      if (this.currentId) {
        if (!this.hasCurrentModel) {
          // no current model => register first model preview in navigation sequence
          const cortonaViewerStore = useCortonaViewerStore();
          cortonaViewerStore.navigateToModel(this.currentId, false);
        }
        this.model = await api.getResource(this.currentId, this.currentVin, this.$i18n.locale);
      }
    },
    removeVIN() {
      this.currentVin = null;
      this.prepareModelData();
    },
    updateVIN(vin) {
      this.currentVin = vin;
      this.prepareModelData();
    },
    onModelNavigation(navigateToUrl) {
      this.currentId = navigateToUrl;
    },
  },
  watch: {
    id(val) {
      this.currentId = val;
    },
    vin(val) {
      this.currentVin = val;
    },
    currentId: {
      immediate: true,
      handler() {
        this.prepareModelData();
      },
    },
    currentVin: {
      handler() {
        this.prepareModelData();
      },
    },
  },
  computed: {
    hasCurrentModel() {
      const cortonaViewerStore = useCortonaViewerStore();
      return cortonaViewerStore.currentModel;
    },
  },
};
</script>

<style lang="scss"></style>
